import { render, staticRenderFns } from "./PermissionsAdminForm.vue?vue&type=template&id=1ce1bd57&scoped=true&"
import script from "./PermissionsAdminForm.vue?vue&type=script&lang=js&"
export * from "./PermissionsAdminForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce1bd57",
  null
  
)

export default component.exports